import React from 'react';

export default function TermosUso() {
  return (
    <div className="container py-5" style={{ maxWidth: '800px' }}>
      <div className="card shadow-sm border p-4 p-md-5 rounded-4 bg-white">
        <h1 className="fw-bold mb-4" style={{ color: 'var(--text-primary)', fontSize: '2rem', borderBottom: '2px solid var(--primary)', paddingBottom: '0.75rem' }}>
          Termos de Uso
        </h1>
        <p className="text-secondary mb-4" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
          Última atualização: 14 de Julho de 2026
        </p>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>1. Aceitação dos Termos</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Ao utilizar o portal de inscrições da <strong>IAC Buritama</strong> para se inscrever ou adquirir ingressos para nossos eventos, você concorda expressamente com os seguintes Termos de Uso. Caso não concorde com qualquer uma das condições estabelecidas, você não deverá utilizar a plataforma.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>2. Cadastro e Responsabilidade do Usuário</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Ao efetuar uma inscrição, o usuário declara e garante que:
          </p>
          <ul className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6', paddingLeft: '1.5rem' }}>
            <li>Todas as informações fornecidas (Nome, E-mail, WhatsApp, CPF) são corretas, completas e verdadeiras;</li>
            <li>É legalmente capaz de celebrar contratos sob as leis aplicáveis;</li>
            <li>Não utilizará dados de terceiros sem a devida autorização expressa dos mesmos.</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>3. Pagamentos e Taxas</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            As inscrições para eventos pagos estão sujeitas a cobrança e serão processadas pelo <strong>Mercado Pago</strong>.
          </p>
          <ul className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6', paddingLeft: '1.5rem' }}>
            <li><strong>Confirmação:</strong> A inscrição só é considerada confirmada após o status do pagamento ser marcado como "aprovado" pelo emissor ou processador;</li>
            <li><strong>Pix Copia e Cola:</strong> Pagamentos pendentes em Pix possuem validade de expiração própria estabelecida no momento da reserva. Não nos responsabilizamos pelo cancelamento automático por falta de pagamento dentro deste prazo;</li>
            <li><strong>Cartão de Crédito/Débito:</strong> O usuário é responsável por garantir limite e dados válidos para a aprovação das transações.</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>4. Cancelamentos, Reembolsos e Transferências</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            As solicitações de cancelamento de inscrições e reembolsos de valores pagos deverão obedecer às regras:
          </p>
          <ul className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6', paddingLeft: '1.5rem' }}>
            <li><strong>Prazo de Reembolso:</strong> O reembolso pode ser solicitado em até 7 (sete) dias corridos após a compra, desde que a solicitação seja feita no mínimo 48 horas antes do início programado do evento;</li>
            <li><strong>Como solicitar:</strong> O pedido deve ser enviado para o e-mail oficial <a href="mailto:iacburitama@gmail.com" style={{ color: 'var(--primary)', textDecoration: 'none' }}>iacburitama@gmail.com</a> contendo o código de inscrição (`INSC_X`);</li>
            <li><strong>Transferência de Ingressos:</strong> A transferência de titularidade de um ingresso para outra pessoa poderá ser feita mediante contato direto e aprovação prévia da organização do evento.</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>5. Alteração ou Cancelamento do Evento</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            A organização reserva-se o direito de:
          </p>
          <ul className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6', paddingLeft: '1.5rem' }}>
            <li>Alterar a programação, data, horário ou local do evento por motivos de força maior ou logística;</li>
            <li>Cancelar o evento. Em caso de cancelamento integral do evento, todos os inscritos serão plenamente reembolsados de acordo com os valores pagos na inscrição.</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>6. Direitos Autorais e Imagem</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Ao participar de nossos eventos presenciais, você concorda que fotos e vídeos feitos durante o evento pela equipe de mídia da <strong>IAC Buritama</strong> contendo sua imagem poderão ser usados institucionalmente para divulgação e arquivamento em nossos canais de mídia oficial, sem qualquer compensação financeira ou direito de reivindicação de imagem.
          </p>
        </section>

        <section className="mb-0">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>7. Alterações nestes Termos</h2>
          <p className="text-secondary mb-0" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Estes Termos de Uso podem ser modificados a qualquer momento pela administração da IAC Buritama. Recomendamos revisar esta página periodicamente. O uso contínuo da plataforma após alterações constitui aceitação dos novos termos.
          </p>
        </section>
      </div>
    </div>
  );
}
